import ClickAwayListener from '@mui/material/ClickAwayListener';

export { ClickAwayListener };
